import { connect } from 'react-redux'
import { compose, withHandlers, setStatic, lifecycle } from 'recompose'
import { withTranslation } from 'react-i18next'
import {
  markThreadRead,
  markThreadUnread,
  selectThread,
  resolveThread,
  unresolveThread
} from '../../../store/actions/discuss'
import onClickOutside from 'react-onclickoutside'
import Thread from './Thread'
import { anonSelector } from '../../../store/selectors/baseSelectors'

const ThreadContianer = compose(
  setStatic('className', Thread.toString()),
  connect(
    (state, { thread }) => ({
      anon: anonSelector(state),
      comments: Object.values(thread.comments || {}).sort(
        (a, b) => a.date - b.date
      )
    }),
    {
      markThreadRead,
      markThreadUnread,
      selectThread,
      resolveThread,
      unresolveThread
    }
  ),
  withHandlers({
    markRead: ({ markThreadRead, thread }) => () => markThreadRead(thread),
    markUnread: ({ markThreadUnread, thread }) => () =>
      markThreadUnread(thread),
    resolveThread: ({ resolveThread, thread }) => () => resolveThread(thread),
    unresolveThread: ({ unresolveThread, thread }) => () =>
      unresolveThread(thread),
    handleClickOutside: ({ selectThread }) => () => {
      selectThread(null)
    }
  }),
  onClickOutside,
  withTranslation(),
  lifecycle({
    componentDidMount() {
      if (!this.props.preview) this.props.markRead()
    }
  })
)

export default ThreadContianer
